import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ current, total, onPageChange }) => {
  if (!total || total <= 1) {
    return null;
  }
  // const getPaginationRange = (current, total) => {
  //   const delta = 1; // how many pages around current

  //   const range = [];
  //   const rangeWithDots = [];

  //   for (
  //     let i = Math.max(2, current - delta);
  //     i <= Math.min(total - 1, current + delta);
  //     i++
  //   ) {
  //     range.push(i);
  //   }

  //   if (current - delta > 2) {
  //     rangeWithDots.push(1, "...");
  //   } else {
  //     rangeWithDots.push(1);
  //   }

  //   rangeWithDots.push(...range);

  //   if (current + delta < total - 1) {
  //     rangeWithDots.push("...", total);
  //   } else {
  //     rangeWithDots.push(total);
  //   }

  //   return rangeWithDots;
  // };

   const getPaginationRange = (current, total) => {
    const delta = 1; // how many pages around current

    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, current - delta);
      i <= Math.min(total - 1, current + delta);
      i++
    ) {
      range.push(i);
    }

    if (current - delta > 2) {
      rangeWithDots.push(1, "...");
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (current + delta < total - 1) {
      rangeWithDots.push("...", total);
    } else {
      rangeWithDots.push(total);
    }

    return rangeWithDots;
  };


  const pages = getPaginationRange(current, total);

  return (
    <div className="flex items-center justify-center gap-1 mt-6">
      <button
        disabled={current === 1}
        onClick={() => onPageChange(current - 1)}
        className="px-1 py-1 border rounded-full flex justify-center items-center disabled:opacity-40"
      >
        <ChevronLeft size={23} />
      </button>

      {pages.map((p, i) =>
        p === "..." ? (
          <span key={i} className="px-2">
            …
          </span>
        ) : (
          <button
            key={i}
            onClick={() => onPageChange(p)}
            className={`h-4 w-4 p-4 rounded-full flex justify-center items-center border ${
              p === current ? "bg-[#FF7043] text-white" : "bg-white"
            }`}
          >
            {p}
          </button>
        ),
      )}

      <button
        disabled={current === total}
        onClick={() => onPageChange(current + 1)}
        className="px-1 py-1 border rounded-full flex justify-center items-center disabled:opacity-40"
      >
        <ChevronRight size={23} />
      </button>
    </div>
  );
};

export default Pagination;
